import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';

import { withClassname } from '@components/hoc/withClassname';
import { OperationalWarehouseForm } from '@modules/operationalWarehouse/operationalWarehouseForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { ActionBar } from '@modules/operationalWarehouse/operationalWarehouseGridButtons';
import { getOperationalWarehouses } from './_operationalWarehouseActions';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';

export const operationalWarehouseUrl = '/metropolis/api/owa/general';
export const operationalWarehouseUrlParametrized = `${operationalWarehouseUrl}/parametrized`;
export const operationalWarehouseLabel = 'Operační sklad';
export const operationalWarehousePath = '/warehouses/operational-warehouse';
export const operationalWarehouseGridName = 'OperationalWarehouseGrid';

export const OperationalWarehouseGrid = compose(
  withRouter,
  setDisplayName(operationalWarehouseGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: operationalWarehouseLabel }]),
  withColumns(Agenda.OPERATIONAL_WAREHOUSE),
  withProps(({ columns }) => ({
    name: operationalWarehouseGridName,
    url: operationalWarehouseUrl,
    Form: OperationalWarehouseForm,
    dialog: false,
    gridProps: {
      columns,
      getItems: getOperationalWarehouses,
      filterRow: true,
      showCheckboxes: true,
      deleting: false,
      filtering: true,
      adding: false,
      sort: 'name',
      locale: 'cz',
      ActionBar,
      pageSize: 50,
      version: 5
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/operationalWarehouse/operationalWarehouseGrid.tsx